export default __webpack_public_path__ + "assets/blue-left-top.svg";